"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAxeptaPaymentStatus = void 0;
class GetAxeptaPaymentStatus {
    constructor(paymentsService) {
        this.paymentsService = paymentsService;
    }
    execute(request) {
        const { idRefill } = request;
        return this.paymentsService.getAxeptaPaymentStatus({ idRefill });
    }
}
exports.GetAxeptaPaymentStatus = GetAxeptaPaymentStatus;
